"use client";

import Link from "next/link";
import LogoSvg from "../LogoSvg";
import BasketHeader from "./BasketHeader";
import FavoriteHeader from "./FavoriteHeader";
import LinkBlog from "./LinkBlog";
import LinkBrands from "./LinkBrands";
import LinkHeader from "./LinkHeader";
import LinkProducts from "./LinkProducts";
import MenuHeader from "./MenuHeader";
import ProfileHeader from "./ProfileHeader";
import SearchHeader from "./SearchHeader";

const HeaderView = () => {
  return (
    <header className="relative">
      <div className="bg-main w-full fixed z-50 top-0 left-1/2 transform -translate-x-1/2">
        <div className="container flex h-16 justify-between items-center mx-auto p-2">
          <div className="flex items-center">
            <div className="md:hidden block">
              <MenuHeader />
            </div>
            <Link className="mr-2" href={"/"}>
              <LogoSvg />
            </Link>
          </div>
          <div className="md:flex hidden items-center">
            {/* <Link className="text-text text-sm mx-2" href={"/categories/عطر"}>
              همه عطرها
            </Link> */}
            <LinkHeader key="category-list" />
            <LinkProducts key="product-list" />
            <LinkBlog key="blog-list" />
            <LinkBrands key="brand-list" />
            <Link href={"/essence"}
              className="text-text text-sm mx-2"
            >
              اسانس ها
            </Link>
            <Link href={"/creator"}
              className="text-text text-sm mx-2"
            >
              سازنده ها
            </Link>
            <Link href={"/about"}
              className="text-text text-sm mx-2"
            >
              درباره ما
            </Link>
            <Link href={"/contact"}
              className="text-text text-sm mx-2"
            >
              تماس با ما
            </Link>
          </div>
          <div className="flex items-center justify-between">
            <BasketHeader />
            <ProfileHeader />
            <FavoriteHeader />
            <SearchHeader />
          </div>
        </div>
      </div>
    </header>
  );
};

export default HeaderView;
